export const principles = [
  { id: "quality", number: "01", title: "Aktuelle Angaben", text: "Preis, Erstzulassung, Laufleistung und Leistung stammen aus dem aktuellen Händlerbestand.", icon: "shield" },
  { id: "price", number: "02", title: "Klare Hinweise", text: "Unfall- und Zustandsangaben bleiben an jedem Angebot sichtbar, bevor Sie Kontakt aufnehmen.", icon: "badge" },
  { id: "concierge", number: "03", title: "Direkter Kontakt", text: "Ihre Anfrage geht ohne Umweg an das Moselcars-Team in Schweich-Issel.", icon: "handshake" },
  { id: "finance", number: "04", title: "Finanzierung", text: "Beispiele zur Monatsrate zeigen wir dort, wo sie im Originalinserat angegeben sind.", icon: "finance" }
];

export const marqueeItems = ["AKTUELLE ANGEBOTE", "A+B AUTOMOBILE", "SCHWEICH-ISSEL", "DIREKTE ANFRAGE", "UNFALLFREI & HINWEISE SICHTBAR"];

export const contactDetails = {
  company: "A+B Automobile",
  address: "Bahndamm 1 · DE-54338 Schweich-Issel",
  mapQuery: "Bahndamm 1, 54338 Schweich-Issel, Deutschland",
  coordinates: "Bahndamm 1 · 54338",
  mapsLink: "https://www.google.com/maps/search/?api=1&query=Bahndamm+1%2C+54338+Schweich-Issel%2C+Deutschland",
  sourceUrl: "https://home.mobile.de/ABAUTOMOBILETRIER",
  email: "moselcars.trier@gmail.com",
  hoursLabel: "Öffnungszeiten bitte telefonisch oder per E-Mail bestätigen"
};
